module.exports = __webpack_public_path__ + "ef1bb203.wav";


//////////////////
// WEBPACK FOOTER
// ./public/images/360831__tec-studios__fantasy-sfx-002.wav
// module id = 1195
// module chunks = 0 1 2